import React, { createContext, useState, useEffect } from 'react';
import { getSettings } from '../utils/api';

export const SettingsContext = createContext({
  vacances: { active: false, debut: '', fin: '', message: '' },
  reloadSettings: () => {}
});

const isVacancesActive = (settings) => {
  if (!settings || Number(settings.vacances_active) !== 1) return false;
  if (!settings.vacances_debut || !settings.vacances_fin) return false;

  const today = new Date().toISOString().slice(0, 10);
  const debut = String(settings.vacances_debut).slice(0, 10);
  const fin = String(settings.vacances_fin).slice(0, 10);

  return today >= debut && today <= fin;
};

export const SettingsProvider = ({ children }) => {
  const [vacances, setVacances] = useState({ active: false, debut: '', fin: '', message: '' });

  const reloadSettings = async () => {
    const settings = await getSettings();
    setVacances({
      active: isVacancesActive(settings),
      debut: settings?.vacances_debut ? String(settings.vacances_debut).slice(0, 10) : '',
      fin: settings?.vacances_fin ? String(settings.vacances_fin).slice(0, 10) : '',
      message: settings?.vacances_message || ''
    });
  };

  useEffect(() => {
    reloadSettings();
    const interval = setInterval(reloadSettings, 300000); // Rafraîchi toutes les 5 min
    return () => clearInterval(interval);
  }, []);

  return (
    <SettingsContext.Provider value={{ vacances, reloadSettings }}>
      {children}
    </SettingsContext.Provider>
  );
};
